import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/firestore'

interface Config {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
  clientId: string;
}

let config: Config

if (process.env.VUE_APP_BRANCHNAME && process.env.VUE_APP_BRANCHNAME === 'master') {
  config = {
    // production
    apiKey: 'AIzaSyDPTH__aRa8-IhpFekSie04VTlggfAWGgw',
    authDomain: 'auth.kontaktlinsen-preisvergleich.de',
    // authDomain: 'app-klpv.firebaseapp.com',
    databaseURL: 'https://app-klpv.firebaseio.com',
    projectId: 'app-klpv',
    storageBucket: 'app-klpv.appspot.com',
    messagingSenderId: '763963147049',
    appId: '1:763963147049:web:9d88f9c4d9bc55d2bced38',
    measurementId: 'G-XGX078QTR5',
    clientId: '763963147049-fk2r26c0imol4p17ikm14rs2e6gl47bn.apps.googleusercontent.com'
  }
} else {
  config = {
    // staging
    apiKey: 'AIzaSyAcrcCaHZEyjAfYW2j_47u1i1VOmPZPZgA',
    authDomain: 'app-klpv-staging.firebaseapp.com',
    databaseURL: 'https://app-klpv-staging.firebaseio.com',
    projectId: 'app-klpv-staging',
    storageBucket: 'app-klpv-staging.appspot.com',
    messagingSenderId: '900056544805',
    appId: '1:900056544805:web:3a28ec3abf1141d1df71cc',
    measurementId: 'G-SC9JPVZZR6',
    clientId: '900056544805-kfjgnv7ntkfltt7ug8no7uv2lv82jqr9.apps.googleusercontent.com'
  }
}

firebase.initializeApp(config)

// enable offline persistence
// firebase.firestore().enablePersistence()

// utils
const db = firebase.firestore()
const auth = firebase.auth()

if (process.env.VUE_APP_USE_EMULATOR) {
  console.info('use local emulator for callables')
  firebase.functions().useFunctionsEmulator('http://localhost:5001')
}

// collection references
// const usersCollection = db.collection('users')
// const postsCollection = db.collection('posts')
// const commentsCollection = db.collection('comments')
// const likesCollection = db.collection('likes')

// export utils/refs
export {
  db,
  auth,
  firebase,
  config
//  usersCollection,
//  postsCollection,
//  commentsCollection,
//  likesCollection
}
